import axios from "axios";
import selectn from "selectn";
import backend from "../utils/backend";
import {
  GET_STORY,
  GET_STORY_SUCCESS,
  GET_STORY_UPDATE,
  GET_STORY_ERROR,
  GET_STORIES_STREAM,
  GET_STORIES_STREAM_SUCCESS,
  GET_STORIES_STREAM_UPDATE,
  GET_STORIES_STREAM_ERROR,
  RESET_STORIES_STREAM_ERROR,
  SET_STORY_STREAM,
} from "../constants/actionTypes";

import { BACKEND_ROOT } from "../config/constants";

export const getStoriesStream = (params, appendResults=false) => {
  return (dispatch) => {
    if (!appendResults) {
      dispatch({
        type: GET_STORIES_STREAM,
      });
    }
    return backend.request({
      method: "GET",
      url: "/stream/",
      params,
    })
      .then((response) => {
        if (!appendResults && !selectn("data.results.length", response)) {
          return dispatch({
            type: GET_STORIES_STREAM_ERROR,
            payload: {
              handleError: true,
              error: { response: { status: 404, message: "API returned empty results" } },
              params,
            },
          });
        }
        return dispatch({
          type: appendResults ? GET_STORIES_STREAM_UPDATE : GET_STORIES_STREAM_SUCCESS,
          payload: response.data.results,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_STORIES_STREAM_ERROR,
          payload: {
            handleError: true,
            error: err,
            params,
          },
        });
      });
  };
};

export const loadNextStory = (params, position, alreadyLoadedStories) => {
  return (dispatch) => {
    dispatch({
      type: GET_STORY,
    });

    return backend.request({
      method: "GET",
      url: "/stream/",
      params,
    })
      .then((response) => {
        let payload;
        let results = response.data.results;

        for (let i = 0; i < results.length; i++) {
          if (!(alreadyLoadedStories || []).includes(results[i].id)) {
            payload = results[i];
            break;
          }
        }

        if (!payload) {
          return dispatch(loadNextStory(
            { ...params, page: (params.page || 1) + 1 },
            position,
            alreadyLoadedStories));
        }

        return dispatch({
          type: GET_STORY_UPDATE,
          payload,
          position,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_STORY_ERROR,
          payload: err,
        });
      });
  };
};

export const loadStory = (params, position, handleError=false) => {
  return (dispatch) => {
    dispatch({
      type: GET_STORY,
    });

    return backend.request({
      method: "GET",
      url: "/stream/",
      params: params || {},
    })
      .then((response) => {
        return dispatch({
          type: position ? GET_STORY_UPDATE : GET_STORY_SUCCESS,
          payload: response.data.results[0],
          position,
        });
      })
      .catch((err) => {
        return dispatch({
          type: GET_STORY_ERROR,
          payload: {
            handleError,
            error: err,
            params,
          },
        });
      });
  };
};

export const loadRevision = (storyId, revision, accessToken, position) => {
  return (dispatch) => {
    dispatch({
      type: GET_STORY,
    });

    return axios.request({
      method: "GET",
      url: `${BACKEND_ROOT}/api/content/${storyId}/revisions/${revision}/`,
      headers: {
        "Authorization": `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        const payload = selectn("data.results[0]", response) ||
          (Array.isArray(response.data) ? selectn("data[0]", response) : response.data) || null;
        return dispatch({
          type: position ? GET_STORY_UPDATE : GET_STORY_SUCCESS,
          payload,
          position,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_STORY_ERROR,
          payload: err,
        });
      });
  };
};

export const loadLatest = (storyId, accessToken, position) => {
  return (dispatch) => {
    dispatch({
      type: GET_STORY,
    });

    return axios.request({
      method: "GET",
      url: `${BACKEND_ROOT}/api/content/${storyId}/`,
      headers: {
        "Authorization": `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        return dispatch({
          type: position ? GET_STORY_UPDATE : GET_STORY_SUCCESS,
          payload: "results" in response.data ? response.data.results[0] : response.data,
          position,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_STORY_ERROR,
          payload: err,
        });
      });
  };
};

export const addStory = (story) => {
  return (dispatch) => {
    return dispatch({
      type: GET_STORY_UPDATE,
      payload: story,
    });
  };
};

export const removeStory = () => {
  return (dispatch) => {
    return dispatch({
      type: GET_STORY_SUCCESS,
      payload: null,
    });
  };
};

export const resetStoriesStreamError = () => {
  return (dispatch) => {
    return dispatch({
      type: RESET_STORIES_STREAM_ERROR,
    });
  };
};

export const setStoryStream = (stories) => {
  return (dispatch) => {
    dispatch({
      type: SET_STORY_STREAM,
      payload: stories,
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/storiesStream.js